'use client';

import type { CatalogueItem } from './homepage-types';

import { useRef, useState } from 'react';
import { CatalogueRail } from './catalogue-rail';
import { CatalogueViewer } from './catalogue-viewer';

type CatalogueBrowserProps = {
  catalogues: CatalogueItem[];
  title: string;
  text: string;
  actionLabel: string;
  openLabel: string;
  previousLabel: string;
  nextLabel: string;
};

/** The selected catalogue in the flipbook; the covers below switch between catalogues. */
export function CatalogueBrowser({
  catalogues,
  title,
  text,
  actionLabel,
  openLabel,
  previousLabel,
  nextLabel,
}: CatalogueBrowserProps) {
  const viewerRef = useRef<HTMLDivElement>(null);
  const [selectedId, setSelectedId] = useState(catalogues[0]?.id);
  const selected = catalogues.find(catalogue => catalogue.id === selectedId) ?? catalogues[0];

  const select = (id: number) => {
    setSelectedId(id);

    // Brings the flipbook back when its top is above the viewport or under the pinned header.
    const viewer = viewerRef.current;
    const pinnedHeight =
      Number.parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    if (viewer && viewer.getBoundingClientRect().top < pinnedHeight) {
      viewer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  if (!selected) return null;

  return (
    <>
      <CatalogueViewer
        key={selected.id}
        ref={viewerRef}
        catalogue={selected}
        title={title}
        text={text}
        actionLabel={actionLabel}
        previousLabel={previousLabel}
        nextLabel={nextLabel}
      />
      <CatalogueRail
        catalogues={catalogues}
        selectedId={selected.id}
        onSelect={select}
        openLabel={openLabel}
        previousLabel={previousLabel}
        nextLabel={nextLabel}
      />
    </>
  );
}
